import { fetchAuthSession } from 'aws-amplify/auth';

export const getUserData = async (userId) => {
  try {
    // Obtener los tokens de Cognito
    const session = await fetchAuthSession();
    const accessToken = session.tokens?.accessToken?.toString();
    const idToken = session.tokens?.idToken?.toString(); // 🎯 ID Token para API Gateway
    
    if (!idToken) {
      throw new Error('No se pudo obtener el ID token');
    }
    
    if (!accessToken) {
      throw new Error('No se pudo obtener el access token');
    }
    
    //console.log('🔐 Obteniendo datos del usuario con token seguro...');
    //console.log('👤 User ID:', userId);
    //console.log('🎫 Access Token (primeros 50 chars):', accessToken.substring(0, 50) + '...');
    //console.log('🆔 ID Token (primeros 50 chars):', idToken.substring(0, 50) + '...');
    
    // 🔍 DEBUG: Analizar ambos tokens JWT
    try {
      //console.log('📊 === ANALIZANDO ACCESS TOKEN ===');
      const accessTokenParts = accessToken.split('.');
      if (accessTokenParts.length === 3) {
        const accessHeader = JSON.parse(atob(accessTokenParts[0]));
        const accessPayload = JSON.parse(atob(accessTokenParts[1]));
        
        //console.log('🔍 Access Token Header:', accessHeader);
        //console.log('🔍 Access Token Payload:');
        //console.log('  - client_id:', accessPayload.client_id);
        //console.log('  - token_use:', accessPayload.token_use);
        //console.log('  - scope:', accessPayload.scope);
        //console.log('  - username:', accessPayload.username);
      }
      
      //console.log('📊 === ANALIZANDO ID TOKEN ===');
      const idTokenParts = idToken.split('.');
      if (idTokenParts.length === 3) {
        const idHeader = JSON.parse(atob(idTokenParts[0]));
        const idPayload = JSON.parse(atob(idTokenParts[1]));
        
        //console.log('🔍 ID Token Header:', idHeader);
        //console.log('🔍 ID Token Payload:');
        //console.log('  - aud (audience):', idPayload.aud);
        //console.log('  - token_use:', idPayload.token_use);
        //console.log('  - cognito:username:', idPayload['cognito:username']);
        //console.log('  - email:', idPayload.email);
        //console.log('  - iss (issuer):', idPayload.iss);
        //console.log('  - exp (expires):', new Date(idPayload.exp * 1000).toISOString());
      }
    } catch (tokenError) {
      console.warn('⚠️ No se pudo decodificar los tokens:', tokenError);
    }
    
    // Hacer la llamada a tu nuevo endpoint seguro
    //const url = `https://4svb468mc6.execute-api.us-east-2.amazonaws.com/prod/v2/users?user_id=${encodeURIComponent(userId)}`;
    const url = `https://4svb468mc6.execute-api.us-east-2.amazonaws.com/prod/v2/users?mode=me`;
    //console.log('🔗 URL completa:', url);
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${idToken}`, // 🎯 Usando ID Token para API Gateway
        'Content-Type': 'application/json',
      }
    });
    
    //console.log('📤 Token enviado: ID Token (para Cognito Authorizer)');
    
    //console.log('📡 Respuesta del servidor:', response.status, response.statusText);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Error del servidor:', errorText);
      
      throw new Error(`Error al obtener datos del usuario: ${response.status} - ${errorText}`);
    }
    
    const userData = await response.json();
    //console.log('✅ Datos del usuario obtenidos:', userData);
    return userData;
    
  } catch (error) {
    console.error('❌ Error en getUserData:', error);
    throw error;
  }
};

// 🧪 Función temporal para probar el endpoint directamente
export const testEndpoint = async (userId, idToken) => {
  //console.log('🧪 TESTING: Probando endpoint directamente...');
  //console.log('🔗 URL:', `https://4svb468mc6.execute-api.us-east-2.amazonaws.com/prod/v2/users?user_id=${userId}`);
  //console.log('🆔 ID Token:', idToken.substring(0, 50) + '...');
  
  // Esta es una función de debugging - puedes probar el endpoint en Postman o similar
  return {
    url: `https://4svb468mc6.execute-api.us-east-2.amazonaws.com/prod/v2/users?user_id=${userId}`,
    headers: {
      'Authorization': `Bearer ${idToken}`, // 🎯 ID Token para testing
      'Content-Type': 'application/json'
    }
  };
}; 